module.exports = __webpack_public_path__ + "img/evaluate-yes1.63d807a9.png";